import React from 'react';
import { Container, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import { koordinasyonKuruluData } from './koordinasyonKuruluData'; // Veriyi import edin
import LeftBar from '../leftbar/LeftBar'

function OrganizasyonKurulu() {
    return (
        <Container>
            <div class="row my-4">
                <div class="col-md-9 kurullar">
                    <Row>
                        {koordinasyonKuruluData.map((team, teamIndex) => (
                            <Col key={teamIndex} md="12" className='my-2'>
                                {/* <h3>{team.teamName}</h3> */}
                                <ul>
                                    {team.members.map((member, memberIndex) => (
                                        <li>
                                            {member.title}
                                        </li>
                                    ))}
                                </ul>
                            </Col>
                        ))}
                    </Row>
                </div>
                <div class="col-md-3">
                    <LeftBar />
                </div>
            </div>
        </Container>
    );
}

export default OrganizasyonKurulu;
